import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '0 24px 24px',
    margin: '-24px',
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    '@media (max-width: 600px)': {
      padding: '0 16px 16px',
      margin: '-24px -16px -16px',
    },
  },
  card: {
    backgroundColor: STYLE.COLOR.WHITE,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '-4px 4px 16px 0px rgba(43, 42, 41, 0.04)',
    '@media (max-width: 600px)': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.CARD_BORDER}`,
    },
  },
  nullBorderTopRadius: {
    borderTopLeftRadius: 0,
    '@media (max-width: 600px)': {
      borderTopLeftRadius: '12px',
    },
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    '@media (max-width: 600px)': {
      padding: '16px',
    },
  },
  sectionTitle: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '140%',
    color: STYLE.COLOR.TEXT1,
  },
  // Header "Add Email" / "Add Mobile" buttons (desktop only)
  headerBtn: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
  },
  // + icon button in header (mobile only)
  addIconBtn: {
    color: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
    padding: '4px !important',
  },
  // Add row — input + Add + Cancel
  addRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    padding: '0 24px 22px',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      padding: '0 16px 22px',
    },
  },
  addInput: {
    flex: 1,
    '@media (max-width: 600px)': {
      width: '100%',
    },
    '& .MuiOutlinedInput-input': {
      fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
      fontSize: '16px !important',
      fontWeight: '400 !important',
      padding: '12px 12px 12px 20px !important',
      '&::placeholder': {
        fontFamily: STYLE.FONT.PRIMARY_FONT,
        fontSize: '16px',
        fontWeight: 400,
        opacity: 1,
      },
    },
  },
  addActions: {
    display: 'flex',
    gap: '8px',
    flexShrink: 0,
    '@media (max-width: 600px)': {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
  addBtn: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
    height: 'auto !important',
    padding: '12px 32px !important',
    borderRadius: '41px !important',
    '@media (max-width: 600px)': {
      flex: '1 !important',
    },
  },
  cancelBtn: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
    height: 'auto !important',
    padding: '12px 24px !important',
    borderRadius: '41px !important',
    '@media (max-width: 600px)': {
      flex: '1 !important',
    },
  },
  // --- MUI Table (desktop) ---
  table: {
    tableLayout: 'fixed' as any,
    width: 'calc(100% - 48px) !important',
    borderCollapse: 'collapse' as any,
    margin: '0 24px !important',
  },
  tableHeadRow: {
    '& th': {
      borderBottom: `1px solid ${STYLE.COLOR.CARD_BORDER}`,
    },
  },
  tableHeaderCell: {
    fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
    fontSize: '12px !important',
    fontWeight: '600 !important',
    lineHeight: '18px !important',
    textTransform: 'uppercase' as any,
    color: `${STYLE.COLOR.TEXT2} !important`,
    padding: '0 12px 10px !important',
    backgroundColor: 'transparent !important',
    border: 'none !important',
  },
  tableDataRow: {
    '& td': {
      border: 'none !important',
      padding: '14px 12px !important',
    },
  },
  tableRowPrimary: {
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
  },
  tableRowSecondary: {
    backgroundColor: STYLE.COLOR.WHITE,
  },
  emailCell: {
    fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
    fontSize: '14px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
    color: `${STYLE.COLOR.TEXT1} !important`,
    overflow: 'hidden !important' as any,
    textOverflow: 'ellipsis !important' as any,
    whiteSpace: 'nowrap !important' as any,
  },
  statusCell: {
    width: '160px',
  },
  primaryBadge: {
    backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
    color: `${STYLE.COLOR.WHITE} !important`,
    fontSize: '10px !important',
    fontWeight: '600 !important',
    fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
    lineHeight: '16px !important',
    textTransform: 'uppercase' as any,
    height: '24px !important',
    borderRadius: '4px !important',
    alignSelf: 'flex-start',
    '& .MuiChip-label': {
      padding: '0 8px',
    },
  },
  secondaryBadge: {
    backgroundColor: `${STYLE.COLOR.TEXT3} !important`,
    color: `${STYLE.COLOR.WHITE} !important`,
    fontSize: '10px !important',
    fontWeight: '600 !important',
    fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
    lineHeight: '16px !important',
    textTransform: 'uppercase' as any,
    height: '24px !important',
    borderRadius: '4px !important',
    alignSelf: 'flex-start',
    '& .MuiChip-label': {
      padding: '0 8px',
    },
  },
  actionsCell: {
    width: '220px',
  },
  actionsCellInner: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px',
  },
  setPrimaryLink: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    color: STYLE.COLOR.TEXT1,
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    whiteSpace: 'nowrap' as any,
  },
  removeLink: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    color: STYLE.COLOR.ERROR,
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    whiteSpace: 'nowrap' as any,
  },
  // margin-top 22px from email list, margin-bottom 24px
  noteBox: {
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    borderRadius: '8px',
    margin: '22px 24px 24px',
    padding: '16px',
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  noteLabel: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px',
    color: STYLE.COLOR.TEXT1,
  },
  noteBody: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    color: STYLE.COLOR.TEXT1,
  },
  emptyText: {
    fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
    fontSize: '14px !important',
    color: `${STYLE.COLOR.TEXT3} !important`,
    textAlign: 'center !important' as any,
    padding: '24px !important',
    border: 'none !important',
  },
  // --- Mobile card layout ---
  mobileContactsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0 16px 16px',
  },
  mobileContactCard: {
    borderRadius: '12px',
    border: `1px solid ${STYLE.COLOR.CARD_BORDER}`,
    overflow: 'hidden',
  },
  mobileContactCardPrimary: {
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
  },
  mobileContactCardSecondary: {
    backgroundColor: STYLE.COLOR.WHITE,
  },
  mobileContactCardContent: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  mobileContactValue: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
  },
  mobileDivider: {
    borderColor: `${STYLE.COLOR.CARD_BORDER} !important`,
    margin: '0 16px !important',
  },
  mobileCardActions: {
    display: 'flex',
    gap: '16px',
    padding: '12px 16px',
  },
  mobileEmptyText: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '14px',
    color: STYLE.COLOR.TEXT3,
    textAlign: 'center' as any,
    padding: '24px 0',
  },
}));
